import { render } from "./InsightsTable.vue?vue&type=template&id=41b7381c"
import script from "./InsightsTable.vue?vue&type=script&lang=js"
export * from "./InsightsTable.vue?vue&type=script&lang=js"

import "./InsightsTable.vue?vue&type=style&index=0&id=41b7381c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTd,QBadge});
